
// AutoPopupMensagem.jsx
import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function AutoPopupMensagem({
  titulo = 'Informação',
  mensagem = 'Aqui vai sua mensagem dinâmica',
  oncePerSession = true,
  oncePersistKey = 'auto-popup:seen',
  persistent = 'session', // 'session' ou 'local'
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Decide storage conforme configuração
    const storage =
      persistent === 'local' ? window.localStorage : window.sessionStorage;

    if (oncePerSession) {
      const seen = storage.getItem(oncePersistKey);
      if (!seen) {
        setOpen(true);
        storage.setItem(oncePersistKey, 'true');
      }
    } else {
      // Sem persistência: abre sempre ao montar
      setOpen(true);
    }
  }, [oncePerSession, oncePersistKey, persistent]);

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        {titulo}
        {/* Botão X no canto superior direito */}
        <IconButton
          aria-label="Close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
          {mensagem}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
